export default function InfoAlert({ info, children }) {
    return (
        <div className="rounded-md bg-blue-50 p-4 border border-blue-400">
            <div className="flex">
                <div className="ml-3 flex-1 md:flex md:justify-between">
                    <p className="">
                        {info}
                        {children}
                    </p>
                </div>
            </div>
        </div>
    )
}
